import { render } from "./InfoPassword.vue?vue&type=template&id=7b5b77ad"
import script from "./InfoPassword.vue?vue&type=script&lang=js"
export * from "./InfoPassword.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\fchristo\\Documents\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__